import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { shiftList } from 'api/frequency';
import { attendanceDailyShiftEdit } from 'api/Attendance';
import Edit from '@/views/Attendance/frequency/modal';
export default {
  components: {
    Edit: Edit
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentShiftId: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      is_all: true,
      form: {
        is_all: 0,
        name: '',
        shift: {} // 所选班次
      },

      page: {
        page: 1,
        size: 1000000000,
        total: 0
      },
      loading: false,
      confirmLoading: false,
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getShiftList();
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    handlerCreateSch: function handlerCreateSch() {
      var msg = {
        title: this.$t('1729'),
        type: 1
      };
      this.$refs.edit.init(msg);
    },
    // 查询
    handlerQuery: function handlerQuery() {
      this.page.page = 1;
      this.getShiftList();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.page.page = currentPage;
      this.getShiftList();
    },
    // 表格禁选
    checkSelectable: function checkSelectable(row) {
      // console.log(row)
      return row.id !== '1';
    },
    // 获取数据
    getShiftList: function getShiftList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _this.form.is_all = _this.is_all ? 0 : 1;
              _context.prev = 2;
              _context.next = 5;
              return shiftList(_objectSpread(_objectSpread({}, _this.form), _this.page));
            case 5:
              res = _context.sent;
              _this.tableData = res.data.result;
              _this.page.total = res.data.count;
              // 表格回显
              _this.updateFormShiftById(_this.currentShiftId, _this.tableData);
            case 9:
              _context.prev = 9;
              _this.loading = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 9, 12]]);
      }))();
    },
    updateFormShiftById: function updateFormShiftById(currentShiftId, tableData) {
      if (!currentShiftId) return;
      var item = tableData.find(function (item) {
        return item.id === currentShiftId;
      });
      if (!item) return;
      this.form.shift = item;
    },
    confirm: function confirm() {
      var _this2 = this;
      if (!this.form.shift || !this.form.shift.id) return;
      var _this$params = this.params,
        staff_id = _this$params.staff_id,
        attendance_date = _this$params.attendance_date;
      this.confirmLoading = true;
      attendanceDailyShiftEdit({
        staff_id: staff_id,
        attendance_date: attendance_date,
        shift_id: this.form.shift.id
      }).then(function () {
        _this2.handleClose();
        _this2.$emit('change');
      }).finally(function () {
        _this2.confirmLoading = false;
      });
    },
    handlerSelection: function handlerSelection(params) {
      this.form.shift = params;
    }
  }
};